import * as uiLib from '@compliance.ai/web-components';
import { logError } from './errors';

export const copyTextToClipboard = async (text: string) => {
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);

      uiLib.showNotification({
        type: uiLib.ALERT_TYPES.SUCCESS,
        message: 'Link copied!'
      });

      return true;
    } catch (e1) {
      //safari fallback
      try {
        const textarea = document.createElement('textarea');
        textarea.value = text;

        textarea.style.position = 'fixed';
        textarea.style.top = '-9999px';
        textarea.style.left = '-9999px';
        textarea.style.opacity = '0';

        document.body.appendChild(textarea);

        textarea.focus();
        textarea.select();

        textarea.setSelectionRange(0, textarea.value.length);

        const successful = document.execCommand('copy');
        document.body.removeChild(textarea);

        uiLib.showNotification({
          type: uiLib.ALERT_TYPES.SUCCESS,
          message: 'Link copied!'
        });

        return successful;
      } catch (e2) {
        if (e1) {
          logError(e1 as Error, 'Error', { isSilent: true });
        }
        if (e2) {
          logError(e2 as Error, 'Error', { isSilent: true });
        }
        uiLib.showNotification({
          type: uiLib.ALERT_TYPES.ERROR,
          message: 'Unable to copy the URL'
        });
        return false;
      }
    }
  }
};
